/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<rect
				opacity="0.4"
				x="14"
				y="3"
				width="7"
				height="18"
				rx="2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="3"
				y="3"
				width="7"
				height="18"
				rx="2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M3 6.2C3 5.0799 3 4.51984 3.21799 4.09202C3.40973 3.71569 3.71569 3.40973 4.09202 3.21799C4.51984 3 5.0799 3 6.2 3H6.8C7.9201 3 8.48016 3 8.90798 3.21799C9.28431 3.40973 9.59027 3.71569 9.78201 4.09202C10 4.51984 10 5.0799 10 6.2V17.8C10 18.9201 10 19.4802 9.78201 19.908C9.59027 20.2843 9.28431 20.5903 8.90798 20.782C8.48016 21 7.9201 21 6.8 21H6.2C5.0799 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V6.2Z"
					fill="currentColor"
				/>
				<path
					d="M14 6.2C14 5.0799 14 4.51984 14.218 4.09202C14.4097 3.71569 14.7157 3.40973 15.092 3.21799C15.5198 3 16.0799 3 17.2 3H17.8C18.9201 3 19.4802 3 19.908 3.21799C20.2843 3.40973 20.5903 3.71569 20.782 4.09202C21 4.51984 21 5.0799 21 6.2V17.8C21 18.9201 21 19.4802 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H17.2C16.0799 21 15.5198 21 15.092 20.782C14.7157 20.5903 14.4097 20.2843 14.218 19.908C14 19.4802 14 18.9201 14 17.8V6.2Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M3 6.2C3 5.07989 3 4.51984 3.21799 4.09202C3.40973 3.71569 3.71569 3.40973 4.09202 3.21799C4.51984 3 5.07989 3 6.2 3H6.8C7.9201 3 8.48016 3 8.90798 3.21799C9.28431 3.40973 9.59027 3.71569 9.78201 4.09202C10 4.51984 10 5.0799 10 6.2V17.8C10 18.9201 10 19.4802 9.78201 19.908C9.59027 20.2843 9.28431 20.5903 8.90798 20.782C8.48016 21 7.92011 21 6.8 21H6.2C5.0799 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V6.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 6.2C14 5.07989 14 4.51984 14.218 4.09202C14.4097 3.71569 14.7157 3.40973 15.092 3.21799C15.5198 3 16.0799 3 17.2 3H17.8C18.9201 3 19.4802 3 19.908 3.21799C20.2843 3.40973 20.5903 3.71569 20.782 4.09202C21 4.51984 21 5.0799 21 6.2V17.8C21 18.9201 21 19.4802 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H17.2C16.0799 21 15.5198 21 15.092 20.782C14.7157 20.5903 14.4097 20.2843 14.218 19.908C14 19.4802 14 18.9201 14 17.8V6.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M2.25 6.25C2.25 4.84987 2.25 4.1498 2.52248 3.61502C2.76217 3.14462 3.14462 2.76217 3.61502 2.52248C4.1498 2.25 4.84987 2.25 6.25 2.25H6.75C8.15013 2.25 8.8502 2.25 9.38498 2.52248C9.85538 2.76217 10.2378 3.14462 10.4775 3.61502C10.75 4.1498 10.75 4.84987 10.75 6.25V17.75C10.75 19.1501 10.75 19.8502 10.4775 20.385C10.2378 20.8554 9.85538 21.2378 9.38498 21.4775C8.8502 21.75 8.15013 21.75 6.75 21.75H6.25C4.84987 21.75 4.1498 21.75 3.61502 21.4775C3.14462 21.2378 2.76217 20.8554 2.52248 20.385C2.25 19.8502 2.25 19.1501 2.25 17.75V6.25Z"
				fill="currentColor"
			/>
			<path
				d="M17.25 2.25C15.8499 2.25 15.1498 2.25 14.615 2.52248C14.1446 2.76217 13.7622 3.14462 13.5225 3.61502C13.25 4.1498 13.25 4.84987 13.25 6.25V17.75C13.25 19.1501 13.25 19.8502 13.5225 20.385C13.7622 20.8554 14.1446 21.2378 14.615 21.4775C15.1498 21.75 15.8499 21.75 17.25 21.75H17.75C19.1501 21.75 19.8502 21.75 20.385 21.4775C20.8554 21.2378 21.2378 20.8554 21.4775 20.385C21.75 19.8502 21.75 19.1501 21.75 17.75V6.25C21.75 4.84987 21.75 4.1498 21.4775 3.61502C21.2378 3.14462 20.8554 2.76217 20.385 2.52248C19.8502 2.25 19.1501 2.25 17.75 2.25H17.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M10 10V6.2C10 5.07989 10 4.51984 9.78201 4.09202C9.59027 3.71569 9.28431 3.40973 8.90798 3.21799C8.48016 3 7.9201 3 6.8 3H6.2C5.07989 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21H6.8C7.92011 21 8.48016 21 8.90798 20.782C9.28431 20.5903 9.59027 20.2843 9.78201 19.908C10 19.4802 10 18.9201 10 17.8V14M14 10V6.2C14 5.0799 14 4.51984 14.218 4.09202C14.4097 3.71569 14.7157 3.40973 15.092 3.21799C15.5198 3 16.0799 3 17.2 3H17.8C18.9201 3 19.4802 3 19.908 3.21799C20.2843 3.40973 20.5903 3.71569 20.782 4.09202C21 4.51984 21 5.0799 21 6.2V17.8C21 18.9201 21 19.4802 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H17.2C16.0799 21 15.5198 21 15.092 20.782C14.7157 20.5903 14.4097 20.2843 14.218 19.908C14 19.4802 14 18.9201 14 17.8V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3 6.2C3 5.07989 3 4.51984 3.21799 4.09202C3.40973 3.71569 3.71569 3.40973 4.09202 3.21799C4.51984 3 5.07989 3 6.2 3H6.8C7.9201 3 8.48016 3 8.90798 3.21799C9.28431 3.40973 9.59027 3.71569 9.78201 4.09202C10 4.51984 10 5.0799 10 6.2V17.8C10 18.9201 10 19.4802 9.78201 19.908C9.59027 20.2843 9.28431 20.5903 8.90798 20.782C8.48016 21 7.92011 21 6.8 21H6.2C5.0799 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V6.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 6.2C14 5.07989 14 4.51984 14.218 4.09202C14.4097 3.71569 14.7157 3.40973 15.092 3.21799C15.5198 3 16.0799 3 17.2 3H17.8C18.9201 3 19.4802 3 19.908 3.21799C20.2843 3.40973 20.5903 3.71569 20.782 4.09202C21 4.51984 21 5.0799 21 6.2V17.8C21 18.9201 21 19.4802 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H17.2C16.0799 21 15.5198 21 15.092 20.782C14.7157 20.5903 14.4097 20.2843 14.218 19.908C14 19.4802 14 18.9201 14 17.8V6.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M17.25 2.25C15.8499 2.25 15.1498 2.25 14.615 2.52248C14.1446 2.76217 13.7622 3.14462 13.5225 3.61502C13.25 4.1498 13.25 4.84987 13.25 6.25V17.75C13.25 19.1501 13.25 19.8502 13.5225 20.385C13.7622 20.8554 14.1446 21.2378 14.615 21.4775C15.1498 21.75 15.8499 21.75 17.25 21.75H17.75C19.1501 21.75 19.8502 21.75 20.385 21.4775C20.8554 21.2378 21.2378 20.8554 21.4775 20.385C21.75 19.8502 21.75 19.1501 21.75 17.75V6.25C21.75 4.84987 21.75 4.1498 21.4775 3.61502C21.2378 3.14462 20.8554 2.76217 20.385 2.52248C19.8502 2.25 19.1501 2.25 17.75 2.25H17.25Z"
				fill="currentColor"
			/>
			<path
				d="M2.25 6.25C2.25 4.84987 2.25 4.1498 2.52248 3.61502C2.76217 3.14462 3.14462 2.76217 3.61502 2.52248C4.1498 2.25 4.84987 2.25 6.25 2.25H6.75C8.15013 2.25 8.8502 2.25 9.38498 2.52248C9.85538 2.76217 10.2378 3.14462 10.4775 3.61502C10.75 4.1498 10.75 4.84987 10.75 6.25V17.75C10.75 19.1501 10.75 19.8502 10.4775 20.385C10.2378 20.8554 9.85538 21.2378 9.38498 21.4775C8.8502 21.75 8.15013 21.75 6.75 21.75H6.25C4.84987 21.75 4.1498 21.75 3.61502 21.4775C3.14462 21.2378 2.76217 20.8554 2.52248 20.385C2.25 19.8502 2.25 19.1501 2.25 17.75V6.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
